import { handleRedirectionWithSignupSource } from '@common/utils'
import useResolution from '@hooks/useResolution'
import Router from 'next/router'
import dynamic from 'next/dynamic'
const FastlyImageDynamic = dynamic(() =>
  import('@components/common/fastly-image')
)

const FirstFold = (): JSX.Element => {
  const {
    sizes: { sm: isMobileDevice },
  } = useResolution()
  return (
    <div className="relative flex justify-between px-5 pt-20 lg:pt-20 lg:px-0 hero-gradient-red-purple">
      <div className="container flex flex-col mx-auto text-white md:px-20 lg:px-20 z-5 lg:flex-row">
        <div className="lg:w-4/6 flex flex-col max-w-6xl">
          <h1 className="max-w-2xl text-5xl leading-tight font-600 lg:text-6xl lg:pr-2">
            Curriculum designed to make kids love coding
          </h1>
          <h2 className="mt-8 text-2xl font-300 lg:pr-2">
            Our unique and engaging coding curriculum is tailored to the
            learning style of every child
          </h2>
          <button
            onClick={() =>
              handleRedirectionWithSignupSource(Router.asPath, '/register')
            }
            className="z-10 w-full px-0 py-4 mt-10 text-xl text-center btn btn-orange lg:mb-5 font-600 lg:w-64"
          >
            Try a free lesson
          </button>
        </div>
        <div>
          <div className="relative flex flex-col items-center justify-center mx-auto">
            {!isMobileDevice && (
              <FastlyImageDynamic
                src="/images/curriculum/first-fold/student-learning.webp"
                alt="students learning coding online"
                width={607}
                height={540}
                priority
              />
            )}
            {isMobileDevice && (
              <FastlyImageDynamic
                src="/images/curriculum/first-fold/penguin-reading-book.webp"
                alt="students learning coding online"
                width={400}
                height={350}
                priority
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FirstFold
